<template>
  <div class="column bg-light-blue-1">
    <div class="col-auto">
      <div class="row items-center">
        <div class="col">
          <span class="attendance">BUSCA GERAL</span>
        </div>

        <div
          v-if="!isPaused"
          class="col-auto cursor-pointer bg-light-blue-1"
          @click="handleAdd"
        >
          <NumKeyboardAndPlus class="add-icon" />
          <q-tooltip>Adicionar Atendimento</q-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ROUTE_SETTINGS, ROUTE_ATTENDANCE_NEW } from '@/router/constants'
import NumKeyboardAndPlus from '@/assets/icons/numKeyboardAndPlus.svg'

export default {
  components: {
    NumKeyboardAndPlus
  },

  data () {
    return {
      filter: ''
    }
  },

  computed: {
    ...mapState({
      isPaused: ({ agentModule }) => Boolean(agentModule?.session?.agent?.paused),
      attendances: (state) => state.attendanceModule
    })
  },

  methods: {
    handleAdd () {
      const vm = this
      vm.$router.push({ name: ROUTE_ATTENDANCE_NEW }).catch(() => {})
      vm.$nextTick().then(() => vm.$root.$emit('focus-target-destination'))
    },

    handleSettings () {
      const vm = this
      vm.$router.push({ name: ROUTE_SETTINGS }).catch(() => {})
    }
  }
}
</script>

<style lang="sass" scoped>
.attendance
  font-size: 12px
  line-height: 14px

.add-icon
  background: #e3f2fd !important

.add-icon > stroke
  fill: #e3f2fd

.add-box
  line-height: 12px

.settings-icon
  width: 19px
  height: 19px

.settings-icon > path
  fill: #37474F

</style>
